import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useReducer,
} from 'react';
import { BillingState, GlobalAction } from '.';
import { billingReducer } from './billingReducer';

type Props = {
  children: ReactNode;
};

type ContextProps = {
  state: BillingState;
  dispatch: React.Dispatch<GlobalAction>;
};

const BillingContext = createContext({} as ContextProps);

const initialState: BillingState = {
  subscription: {
    card: {},
    plan: {},
    upcomingInvoice: {},
    loading: false,
    totalActiveUsers: 0,
    totalAllowedUsers: 0,
    addons: [],
    cancelAt: null,
    currentPeriodEnd: null,
    nextPeriodStart: null,
  },
  invoices: {
    items: [], //[{firstName: 'Akansh', amount: 200}],
    hasMore: false,
    loading: false,
  },
  cards: {
    items: [],
    hasMore: false,
    loading: true,
  },
};

export const BillingContextProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(billingReducer, initialState);
  const value = useMemo(() => ({ state, dispatch }), [state]);
  return (
    <BillingContext.Provider value={value}>{children}</BillingContext.Provider>
  );
};

export const useBillingContext = () => useContext(BillingContext);
